import { render, staticRenderFns } from "./AdRankingGauge.vue?vue&type=template&id=024a4c90&scoped=true"
import script from "./AdRankingGauge.vue?vue&type=script&lang=js"
export * from "./AdRankingGauge.vue?vue&type=script&lang=js"
import style0 from "./AdRankingGauge.vue?vue&type=style&index=0&id=024a4c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024a4c90",
  null
  
)

export default component.exports